import { fetchGet, fetchPost } from "../services/Apiservice"

export const settingsList = (data) => {
    return fetchGet('/settings', data)
        .then((res) => {
            return res
        })
        .catch((res) => {
            throw res
        })
}

export const settingsUpdate  = (data) => {

    return fetchPost(`/settings/update`, data)
        .then(res => res)
        .catch(err => { throw err })
}

export const settingsGetByKey = (key) => {
    return fetchGet(`/settings?key=${key}`)
        .then((res) => {
            return res
        })
        .catch((res) => {
            throw res
        })
}
